import { Outlet } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";

const ProtectedLayout = () => {
  return (
    <MasterLayout>
      <Outlet />
    </MasterLayout>
  );
};

export default ProtectedLayout;
